import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  public title: string;
  public message: string;
  public anotherMessage: string;
  public confirmMessage: string;
  public cancelButton: boolean;
  public okButtonText: string;
  public bypassTranslation: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any) {
  }

  ngOnInit(): void {
    this.title = this.dialogData.title;
    this.message = this.dialogData.message;
    this.bypassTranslation = this.dialogData && this.dialogData.bypassTranslation ? this.dialogData.bypassTranslation : false;
    this.anotherMessage = this.dialogData && this.dialogData.anotherMessage ? this.dialogData.anotherMessage : null;
    this.confirmMessage = this.dialogData && this.dialogData.confirmMessage ? this.dialogData.confirmMessage : null;
    this.okButtonText = this.dialogData && this.dialogData.okButtonText ? this.dialogData.okButtonText : null;
    if (this.dialogData.cancelButton === false) {
      this.cancelButton = this.dialogData.cancelButton;
    } else {
      this.cancelButton = true;
    }
  }

  @HostListener('click', ['$event'])
  onContentClick(event: MouseEvent): void {
    const target = event ? (event.target as HTMLElement) : null;
    if (!target) {
      return;
    }

    const btn = target.closest ? (target.closest('.btn-toggle-show-more') as HTMLElement) : null;
    if (btn) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      const wrapper = btn.closest ? (btn.closest('.field-name-wrapper') as HTMLElement) : null;
      if (wrapper) {
        if (wrapper.classList.contains('is-expanded')) {
          wrapper.classList.remove('is-expanded');
        } else {
          wrapper.classList.add('is-expanded');
        }
      }
      return;
    }

    const accordionHeader = target.closest ? (target.closest('.dep-accordion-header, .dep-parent-accordion-header') as HTMLElement) : null;
    if (accordionHeader) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      const item = accordionHeader.closest('.dep-accordion-item, .dep-parent-accordion-item') as HTMLElement;
      if (item) {
        item.classList.toggle('is-open');
      }
    }
  }
}
